<template>
    <div>
        <h1 class="mb-1">Marktdurchdringung 2
            <v-tooltip right>
                <template v-slot:activator="{ on }">
                    <v-icon @click.stop="dialog = true" color="primary" class="ml-2" dark v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>Beschreibung</span>
            </v-tooltip>
        </h1>
        <div class="mb-5 grey--text text--darken-1 font-regular">Welchen Website Traffic generieren Sie von Personen, die nach Produkten und nicht nach Ihrem Unternehmen suchten?</div>

        <v-dialog v-model="dialog" max-width="500">
            <v-card>
                <v-card-title class="headline">Marktdurchdringung</v-card-title>
                <v-card-text>
                        <p>Diese Werte zeigen an, wie wie gross Ihr Marktanteil bei Leuten ist, die nach Produkten suchen, ohne Ihren Firmennamen zu nennen. Mit dem Suchbegriff "Ihre Marke" ist es mit www.ihre-marke.ch einfach, bei Google zu erscheinen. Mit dem Suchbegriff “Sofa weiss” hingegen messen Sie sich direkt mit den Mitbewerbern Ihres Unternehmens.</p>
                        <p><strong>Der linke Wert ist die Anzahl Suchbegriffe, mit denen Ihre Webseite bei Google in den ersten 10 Positionen angezeigt wird.</strong> Aus diesem Wert erkennen Sie die Leistungsfähigkeit Ihres Unternehmens, neue Marktanteile zu gewinnen.</p>
                        <p><strong>Der rechte Wert in jeder Zeile drückt aus, wie viele Webseitenbesucher effektiv aus diesen Suchbegriffen für Sie resultieren.</strong> Vergleichen Sie die Entwicklung dieser Kundenaquise im ‘freien Markt’ Ihres eigenen Unternehmens mit der Entwicklung Ihrer Mitbewerber.</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="product-small" v-if="preview">
            <v-progress-linear :indeterminate="true" v-if="loading" />
            <apex-line-chart :x="traffic.chart.x" :y="traffic.chart.y" height="400" :format="price" :tooltip="tooltip" v-if="!loading" />
        </div>
        
        <div class="product-full" v-if="!preview">
            <v-progress-linear :indeterminate="true" v-if="loading" />

            <v-card v-if="!loading">
                <v-card-text>
                    <v-data-table :hide-default-footer="true" :headers="traffic.table.header" :items="traffic.table.body" class="elevation-1" mobile-breakpoint="0">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td v-for="(c, i) in traffic.table.header" :key="i" :align="i ? 'right' : 'left'" style="padding:8px">
                                    <div v-if="c.value == 'domain'" class="d-flex flex-column">
                                        <div class="non-branded-table-title">{{ item[c.value] }}</div>
                                        <div class="non-branded-table-subtitle mt-2">Webseitenbesucher</div>
                                        <div class="non-branded-table-subtitle"><br /></div>
                                        <div class="non-branded-table-subtitle">Suchbegriffe</div>
                                        <div class="non-branded-table-subtitle"><br /></div>
                                    </div>
                                    <div v-if="c.month" class="d-flex flex-column">
                                        <div class="non-branded-table-title"></div>
                                        <div>
                                            {{ price(item[c.value].traffic) }}
                                        </div>
                                        <div>
                                            <small>
                                                <growth :value="item[c.value].trafficGrowth" />
                                            </small>
                                        </div>
                                        <div class="mt-2">
                                            {{ price(item[c.value].keywords) }}
                                        </div>
                                        <div>
                                            <small>
                                                <growth :value="item[c.value].keywordsGrowth" />
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="c.value == 'total'" class="d-flex justify-center font-weight-bold subtitle-1">
                                        <div class="non-branded-table-title"></div>
                                        <growth :value="item.growth" />
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>

            <v-row v-if="!loading">
                <v-col cols="6">
                    <v-card class="mt-10">
                        <v-card-text>
                            <v-tabs color="primary" class="pl-3" v-if="loaded">
                                <v-tabs-slider color="primary"></v-tabs-slider>
                                <v-tab href="#traffic">Webseitenbesucher</v-tab>
                                <v-tab href="#keywords">Suchbegriffe</v-tab>

                                <v-tab-item value="traffic">
                                    <apex-line-chart :x="traffic.chart.x" :y="traffic.chart.y" height="400" :format="price" :tooltip="tooltip" v-if="!loading" />
                                </v-tab-item>

                                <v-tab-item value="keywords">
                                    <apex-line-chart :x="keywords.chart.x" :y="keywords.chart.y" height="400" :format="price" :tooltip="tooltip" v-if="!loading" />
                                </v-tab-item>
                            </v-tabs>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="6">
                    <v-card class="mt-10">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" lg="6">
                                        <v-data-table :hide-default-footer="true" :headers="share.table.header" :items="share.table.body" class="elevation-1 non-branded-table" mobile-breakpoint="0">
                                            <template v-slot:item="{ item }">
                                                <tr>
                                                    <td>{{ item.domain }}</td>
                                                    <td class="text-right">{{ item.year.trafficShare }}%</td>
                                                    <td class="text-right">
                                                        <growth :value="item.year.trafficGrowth" />
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <apex-donut-chart :x="share.chart.x" :y="share.chart.y" :format="price" :tooltip="price" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<style scoped>
    .non-branded-table-title {
        font-weight: bold;
        height: 1.5em;
        font-size: 1.2em;
    }
    .non-branded-table-subtitle {
        opacity: .5;
        font-size: .9em;
    }
</style>

<script>
import ApexLineChart from "@/components/charts/ApexLineChart";
import ApexDonutChart from "@/components/charts/ApexDonutChart";
import Growth from "@/components/common/Growth";
import ProductMixin from "@/mixins/Product";
import { headers } from "@/helpers/table";
import moment from "moment";
import { price } from "@/helpers/format";

export default {
    data: () => ({
        dialog: false,
        traffic: {
            table: { header: [], body: [] },
            chart: { x: [], y: [] }
        },
        keywords: {
            chart: { x: [], y: [] }
        },
        share: {
            table: { header: [], body: [] },
            chart: { x: [], y: [] }
        }
    }),
    mixins: [ProductMixin],
    methods: {
        price,
        tooltip(value, growth) {
            let s = price(value);

            if (growth === null)
                s += ` ∞`;
            else if (growth < 0)
                s += ` <span class="red--text">${growth}%</span>`;
            else if (growth > 0)
                s += ` <span class="green--text">+${growth}%</span>`;
            else
                s += ` 0%`;

            return s;
        },
        async loaded(data) {
            this.traffic.table.header = headers([
                { text: 'Domain', value: 'domain' },
                ...data.months.map(m => ({
                    text: moment(m).format("MMM YY"),
                    value: m,
                    align: 'right',
                    month: true
                }))
            ]);

            this.traffic.table.body = data.domains.map(d => Object.assign({
                    domain: d.domain,
                    growth: d.lastMonth.growth
                },
                ...d.months.map(m => ({
                    [m.date]: m
                }))
            ));

            if (this.mode !== "preview") {
                this.traffic.table.header.push(...headers([{
                    text: "Wachstum über 12 Monate",
                    align: 'center',
                    value: 'total',
                    width: '120',
                }]));
            }

            this.traffic.chart.x = data.months.map(d => moment(d).format("MMM YY"));
            this.traffic.chart.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.traffic),
                tooltip: d.months.map(m => m.trafficGrowth)
            }));

            this.keywords.chart.x = data.months.map(d => moment(d).format("MMM YY"));
            this.keywords.chart.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.keywords),
                tooltip: d.months.map(m => m.keywordsGrowth)
            }));

            this.share.chart.x = data.domains.map(d => d.domain);
            this.share.chart.y = data.domains.map(d => d.year.traffic);

            this.share.table.header = headers([
                { text: 'Domain' },
                { text: 'Marktanteil', align: 'right' },
                { text: 'Vgl. Vorjahr', align: 'right' },
            ]);
            this.share.table.body = data.domains;

            return Promise.resolve();
        }
    },
    components: { Growth, ApexLineChart, ApexDonutChart }
}
</script>